import React, { Component } from 'react';
import Header from './Header.js';
import ProgressBar from './ProgressBar.js';
import './ProjectDetail.css';
import fire from './fire';
import MapComponent from './Map.js';
import _ from 'lodash';
import TaskWidget from './TaskWidget.js';
import {FormGroup, Button, FormControl} from 'react-bootstrap';


class ProjectDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      project: {},
    };
  }

  componentDidMount() {
    const {
      projectId
    } = this.props.match.params;

    var projectRef = fire.database().ref('projects/' + projectId);
    projectRef.on('value', (snapshot) => {
      this.setState({project: snapshot.val()});
    });
  }

  render() {
    const {
      name,
      description,
      globalGoals,
      solutions,
      status,
      location,
      latLng
    } = this.state.project;

    console.log(latLng);

    _.map(solutions)

    let tasks = [];
    if (solutions && solutions.length > 0) {
      _.each(solutions, (solution, index) => {
        if(solution) {
          tasks.push(_.assign({}, solution.tasks[1], {solutionId: index, upvotes: solution.upvotes}));
        }
      })
    }

    const sortedTasks = tasks.sort((a,b) => b.upvotes - a.upvotes)

    return (
      <div className="project-detail">
        <Header/>
        <ProgressBar status={status}/>
        <div className="project-detail--title">
          <h2>{name}</h2>
        </div>
        <div className="project-detail--location">
          {location}
        </div>
        <MapComponent latLng={latLng} />
        <h3>Project Description</h3>
        <p>{description}</p>
        {(status === 0) && 
          (<div>
            <h3>Suggested solutions</h3>
            {
              sortedTasks.map((task, index) => (
                <TaskWidget task={task} enableUpvote key={index} />
              ))
            }
            <h3>Suggest a solution</h3>
            <FormGroup>
              <FormControl rows="3" componentClass="textarea" />
              <Button>Submit</Button>
            </FormGroup>
          </div>
        )}
        {(status === 1) && 
          (<div>
            <h3>Tasks</h3>
            {
              sortedTasks.map((task, index) => (
                
                <TaskWidget 
                  onClick={() => {
                    this.props.history.push(`/projects/${this.props.match.params.projectId}/solutions/${task.solutionId}/tasks/1`);
                  }}
                  task={task} 
                  key={index} />
              ))
            }
          </div>
        )}
        
        
      </div>
    );
  }
}

export default ProjectDetail;



// WEBPACK FOOTER //
// ./src/ProjectDetail.js